

export enum EnumSexo {
    NaoInformado,
    Masculino,
    Feminino
}
